declare let __BUILD_TIMESTAMP__: string;

import { NativeDesktopSupport } from "app/bfx-native-desktop/native-desktop-support";

export const bootstrap_theme = function bootstrap_theme(themeElement, name, url) {
  let el = document.createElement("img");
  el.setAttribute("src", url);

  if (themeElement == null) {
    let link = document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.type = "text/css";
    link.id = "theme-id";
    link.href = `${url}?v=${__BUILD_TIMESTAMP__}`;
    document.head.appendChild(link);

    themeElement = link;
  }

  let rejectTimeoutId = setTimeout(function () {
    throw new Error("Failed to load CSS for package: " + name);
  }, 120000);

  el.addEventListener("error", () => {
    clearTimeout(rejectTimeoutId);

    if (el.parentNode) {
      el.parentNode.removeChild(el);
    }

    requestAnimationFrame(() => {
      // is isn't very useful. better to use keyframe visibility
      themeElement.setAttribute("href", `${url}?v=${__BUILD_TIMESTAMP__}`);
      themeElement.dataset.ready = "true";
      themeElement.dataset.name = name;
      themeElement.dispatchEvent(new Event("ready"));

      NativeDesktopSupport.updateWindowTheme(name);
    });
  });
};
